export default __webpack_public_path__ + "static/media/integrator.4e775e49.svg";